import { render, staticRenderFns } from "./SocialMappingBox.vue?vue&type=template&id=db6c95dc&"
import script from "./SocialMappingBox.vue?vue&type=script&lang=ts&"
export * from "./SocialMappingBox.vue?vue&type=script&lang=ts&"
import style0 from "./SocialMappingBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports